import { createApi } from '@reduxjs/toolkit/query/react';
import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import { isEmpty } from 'lodash';
import { onUserProfile } from './authSlice';
import { RootState } from '..';
import { SettingsProp } from '../../components/Admin/Settings/store/applicationSettingsSlice';

const baseUrl = `${import.meta.env.VITE_API_URL}api/`;

export const baseUrlWithCustomHeader = fetchBaseQuery({
  baseUrl,
  prepareHeaders: (headers, { getState }) => {
    // By default, if we have a token in the store, let's use that for authenticated requests
    const getToken = getState() as RootState;
    const { token } = getToken.auth;
    if (!isEmpty(token)) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

interface ProfileGropsInterface {
  id: number;
  name: string;
}
interface ProfileInterface {
  first_name: string;
  groups: ProfileGropsInterface[];
  id: string;
  last_name: string;
  permissions: string[];
  username: string;
  designation_name: string;
  project_name: string;
  email: string;
  phone: string;
  phone2: string;
  image: string;
  about: string;
  awards: any[];
  hobbies: string;
  status: string;
  extension: string;
  gender: string;
  user_settings: any;
  application_settings: SettingsProp[];
  staff_pin: string;
}

export const api = createApi({
  reducerPath: 'api',
  baseQuery: baseUrlWithCustomHeader,
  endpoints: (builder) => ({
    getUserProfile: builder.query<ProfileInterface, void>({
      query: () => {
        return `v2/main/user/profile/`;
      },
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(onUserProfile(data));
        } catch (__err) {
          // console.log('profile data error', err);
        }
      },
    }),
  }),
});

export const { useGetUserProfileQuery } = api;
